import {Component, Input} from '@angular/core';
import {Modal} from "../modal";
import {ModalController} from "@ionic/angular";
import {Filters} from "../../models/models";
import {Utils} from "../../utils/utils";

@Component({
  selector: 'app-filter-modal',
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.scss'],
})
export class FilterModalComponent extends Modal {
  @Input() defaultFilters: Filters;
  @Input() filters: Filters;

  constructor(
    modalCtrl: ModalController
  ) {
    super(modalCtrl);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  resetFilters() {
    this.filters = Utils.copy(this.defaultFilters);
  }

  getFilters() {
    const filters = [];
    for (let filter of Object.values(this.filters)) {
      if (filter.editable) {
        filters.push(filter);
      }
    }
    return filters;
  }
}
